import { Field } from '@approvalmax/ui';
import { selectors } from 'modules/common';
import { constants } from 'modules/common';
import { memo } from 'react';

import { messages } from './PhoneEditor.messages';
import { AreaEditor, CountryEditor, NumberEditor, Root } from './PhoneEditor.styles';
import { PhoneEditorProps } from './PhoneEditor.types';

const { xeroConstants } = constants;

export const PhoneEditor = memo<PhoneEditorProps>((props) => {
    const { phone, name, title, qa, showErrors, onChange } = props;

    const isInvalidCountryCode = !!(
        phone.countryCode &&
        (!phone.countryCode?.trim() ||
            phone.countryCode.length > xeroConstants.PHONE_COUNTRY_CODE_MAX_LENGTH ||
            !selectors.ui.isValidPhone(phone.countryCode))
    );

    const isInvalidAreaCode = !!(
        phone.areaCode &&
        (!phone.areaCode?.trim() ||
            phone.areaCode.length > xeroConstants.PHONE_AREA_CODE_MAX_LENGTH ||
            !selectors.ui.isValidPhone(phone.areaCode))
    );

    const isInvalidNumber = !!(
        phone.number &&
        (!phone.number?.trim() ||
            phone.number.length > xeroConstants.PHONE_NUMBER_MAX_LENGTH ||
            !selectors.ui.isValidPhone(phone.number))
    );

    return (
        <Root>
            <Field title={title}>
                <CountryEditor
                    qa={qa(`${name}-phone-country-editor`)}
                    theme='transparent'
                    maxLength={xeroConstants.PHONE_COUNTRY_CODE_MAX_LENGTH}
                    value={phone.countryCode || ''}
                    onChange={onChange(name, 'countryCode')}
                    placeholder={messages.countryCodePlaceholder}
                    invalid={showErrors && isInvalidCountryCode}
                />
            </Field>

            <Field title={null}>
                <AreaEditor
                    qa={qa(`${name}-phone-area-editor`)}
                    theme='transparent'
                    maxLength={xeroConstants.PHONE_AREA_CODE_MAX_LENGTH}
                    value={phone.areaCode || ''}
                    onChange={onChange(name, 'areaCode')}
                    placeholder={messages.areaCodePlaceholder}
                    invalid={showErrors && isInvalidAreaCode}
                />
            </Field>

            <Field title={null}>
                <NumberEditor
                    qa={qa(`${name}-phone-number-editor`)}
                    theme='transparent'
                    maxLength={xeroConstants.PHONE_NUMBER_MAX_LENGTH}
                    value={phone.number || ''}
                    onChange={onChange(name, 'number')}
                    placeholder={messages.phoneNumberPlaceholder}
                    invalid={showErrors && isInvalidNumber}
                />
            </Field>
        </Root>
    );
});

PhoneEditor.displayName = 'PhoneEditor';
